// extracted by mini-css-extract-plugin
export default {"address":"sgt4F8kSGq5XyNhqbg_5"};